import React from "react";

// Returns a React SVG component so that we may change the fill color and/or icon size of the SVG to whatever we want dynamically across hundreds of different websites and hundreds of different colors.
// This react component is the mobile phone SVG icon, typically used for the Save to Phone or "Save" CTA.
const WatchVideo = ({ both, fill, svgIconSize, padding, margin, hideCtaIcons }) => {
    return (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 -50 500 500"
            style={{
                pointerEvents: "none",
                width: both ? "25px" : svgIconSize,
                height: both ? "25px" : svgIconSize,
                padding: padding ? padding : null,
                margin: margin ?? null,
                flexShrink: 0,
                fill: "inherit",
                display: hideCtaIcons ? "none" : "unset",
            }}
            xmlSpace="preserve"
        >
            <g>
                <path d="M511.8,40c0,98.6,0,197.3,0,295.9c-8.7-4.2-17.4-8.2-26-12.5c-23.4-11.5-46.7-23.2-70.1-34.6c-2.8-1.4-3.8-3-3.7-6.1 c0.1-63.1,0.1-126.2,0-189.3c0-2.7,0.3-4.5,3.1-5.9c31.6-15.5,63.2-31.2,94.8-46.9C510.5,40.2,511.2,40.1,511.8,40z M375.7,46 c0,94.6,0.1,189.2,0,283.7c0,22-13.2,39.4-33.6,44.6c-4.7,1.2-9.4,1.5-14.3,1.5c-62.4-0.1-124.9,0-187.3-0.1c-1.8,0-3.7-0.1-5.5-0.2 c-31,0-62,0.4-92.9,0c-18.6-0.3-34.6-13.5-40.1-31.3c-0.5-1.5-0.2-3.4-1.9-4.4C0,238.5,0,137.2,0,36c1.6-0.8,1.4-2.6,1.8-3.9 c5.9-19.3,22.5-31.9,42.8-32c31.3-0.1,62.6,0,93.9,0c62.6,0,125.2,0,187.8,0c7.1,0,14.2,0.2,20.7,3.5c12.8,3,25.5,18.1,27.8,33 C375.3,39.7,375.7,42.8,375.7,46z M209.9,241.4c0,0.8-0.1,1.5-0.4,2.2C209.8,242.9,209.9,242.2,209.9,241.4z M273,171.9 c-5.4-3.3-10.8-6.5-16.2-9.7c-7.5-4.2-15.1-8.4-22.6-12.7c-26.2-15-52.3-30.2-78.6-45.1c-8.9-5.1-16.7-3.4-23.5,4.1 c-3.5,3.9-3.6,8.7-3.6,13.5c0,43.8,0,87.6,0,131.4c0,1.5,0,3,0.1,4.5c0.8,9.1,8.1,15.9,17.2,16.2c4.2,0.1,7.8-1.3,11.3-3.3 c17.5-10.1,35-20.1,52.6-30.1c0,0,0,0,0,0c21.1-12.2,42.2-24.4,63.2-36.8C286.2,196.1,286.1,179.9,273,171.9z M164.6,155 c0,22,0,43.9,0,65.9c0,2.6,0.4,3.9,3.3,2.2c20-11.6,40-23.1,60.9-35.2c-21-12.1-41-23.6-61-35.3C164.5,150.7,164.6,152.8,164.6,155z "></path>
            </g>
        </svg>
    );
};

export default WatchVideo;
